import React, { useEffect, useState } from "react";
import grass from "../../Asset/banner/grass.png";
import blur from "../../Asset/banner/blur.png";

const HomeBanner = ({ bannerlist }) => {
  const [indexstatus, setIndexStatus] = useState(0);
  const banners = bannerlist?.banner || [];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndexStatus((prevIndex) => (prevIndex + 1) % banners.length);
    }, 16000);

    return () => clearInterval(interval);
  }, [banners.length]);

 

  return (
    <div className="w-full bg-Background3 h-1/2 relative overflow-hidden">
      {/* Background blur image */}
      <div className="w-3/5 absolute top-0 left-0 z-0">
        <img src={blur} alt="blur" className="w-full" />
      </div>

      {/* Grass image overlay */}
      <div className="relative z-10 w-full top-5 sm:top-0">
        <div className="w-full">
          <img src={grass} alt="grass" className="w-full" />
        </div>

        {/* Banner content */}
        <div className="relative -top-5 sm:-top-2 md:-top-20 w-full flex flex-col justify-center items-center">
          <div
            className="w-full  px-0.5 md:px-12 cursor-pointer h-40 sm:h-full"
            onClick={() => {
              const link = banners[indexstatus]?.link;
              if (link) {
                window.open(link, "_blank");
              }
            }}
          >
            <img
              src={banners[indexstatus]?.image}
              className="w-full h-full object-fill sm:object-cover rounded-xl md:rounded-3xl"
              alt="banner"
            />
          </div>

          {/* Dots for switching banners */}
          <div className="w-full flex gap-4 justify-end px-8 mx-5 mt-6">
            {bannerlist?.banner.map((item, index) => (
              <div
                key={index}
                className={`p-2 rounded-full border cursor-pointer transition ${
                  indexstatus === index ? "bg-textColor" : "bg-Background4"
                }`}
                onClick={() => setIndexStatus(index)}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
